export default __webpack_public_path__ + "static/media/creddit-screen1.aad85175.png";